import React from 'react';

/** "Paso 2 de 3" with three short bars; the current and finished steps are brand blue. */
export default function StepProgress({ current, total }) {
    return (
        <div className="flex flex-col items-end gap-1.5">
            <span className="text-xs font-medium tabular-nums text-surface-500">
                Paso {current + 1} de {total}
            </span>
            <div className="flex gap-1" aria-hidden="true">
                {Array.from({ length: total }, (_, i) => (
                    <span key={i} className={`h-1 w-6 rounded-full transition-colors ${i <= current ? 'bg-primary-600' : 'bg-surface-200'}`} />
                ))}
            </div>
        </div>
    );
}
